export enum Portal {
    User = 1,
    Admin
}
